const ScreenWidthCalc=(id,Data)=>{
    
  return   document.documentElement.clientWidth

};


export default ScreenWidthCalc;